import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { api } from '@@/services/api';
import auth from '@@/features/auth';
import modal from '@@/features/modal';
import { rtkQueryErrorHandler } from '@@/middlewares/errorHandler';

import {
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const persistConfig = {
  key: 'alacaza-pro',
  version: 1,
  storage,
  whitelist: ['auth'],
};

const rootReducer = combineReducers({
  auth: auth.reducer,
  modal: modal.reducer,
  [api.reducerPath]: api.reducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  // En embed, main.tsx n'appelle pas persistStore : sans l'action PERSIST,
  // persistReducer ne crée pas son persistoid, donc rien n'est écrit dans le
  // localStorage et aucun REHYDRATE ne vient écraser le token injecté par le
  // parent. C'est ce qu'on veut : le localStorage d'une iframe tierce est
  // partitionné (voire bloqué par Safari), et le token est de toute façon
  // réinjecté à chaque chargement.
  reducer: persistedReducer,
  // Adding the api middleware enables caching, invalidation, polling,
  // and other useful features of `rtk-query`.
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(api.middleware, rtkQueryErrorHandler),
});

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
